import React, { useRef } from 'react';
import { FaFilePdf, FaArrowUp, FaTrash } from 'react-icons/fa';
import { DocumentRow, DocumentInfo, DocumentActions, SelectFileButton, FileInfo,
RemoveButton, RequiredBadge, OptionalBadge, ConditionalBadge, DocumentErro } from './styles';

const getBadge = (documento) => {
  if (documento.required) return <RequiredBadge>Obrigatório</RequiredBadge>;
  if (documento.conditional) return <ConditionalBadge>Quando aplicável</ConditionalBadge>;
  return <OptionalBadge>Opcional</OptionalBadge>;
};

const DocumentUploadItem = ({ documento, file, onUpload, onRemove, disabled, loading, erro, pendente }) => {
  const fileInputRef = useRef(null);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      onUpload(documento.id, file);
    }
    // Limpa o input para permitir selecionar o mesmo arquivo novamente
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleClick = () => {
    if (!disabled && !loading) {
      fileInputRef.current?.click();
    }
  };

  return (
    <DocumentRow data-field-name={documento.id} $destaque={Boolean(erro || pendente)}>
      <DocumentInfo>
        <strong>
          {documento.name}
          {getBadge(documento)}
        </strong>
        <small>{documento.description}</small>
      </DocumentInfo>
      <DocumentActions>
        {file ? (
          <FileInfo>
            <FaFilePdf color="#ef4444" />
            <span title={file.name}>{file.name}</span>
            <RemoveButton onClick={() => onRemove(documento.id)} disabled={disabled} aria-label="Remover arquivo">
              <FaTrash size={12} />
            </RemoveButton>
          </FileInfo>
        ) : (
          <>
            <input
              ref={fileInputRef}
              type="file"
              style={{ display: 'none' }}
              onChange={handleFileSelect}
              accept=".pdf,application/pdf"
              disabled={disabled || loading}
            />
            <SelectFileButton onClick={handleClick} disabled={disabled || loading}>
              <FaArrowUp size={12} />
              Selecionar PDF
            </SelectFileButton>
          </>
        )}
      </DocumentActions>
      {(erro || (pendente && !file)) && (
        <DocumentErro role="alert">
          {erro || 'Este documento é obrigatório'}
        </DocumentErro>
      )}
    </DocumentRow>
  );
};

export default DocumentUploadItem;
